import React, { useState, useContext, useEffect } from "react";
import {
	Box,
	Typography,
	Button,
	TextField,
	Grid,
	Divider,
	FormControlLabel,
	Checkbox,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CreatorContext } from "../../context/CreatorContext";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Product1 from "../../assets/product1.png";
import Product2 from "../../assets/product2.png";
import Product3 from "../../assets/product3.png";
import Product4 from "../../assets/product4.png";
import Product5 from "../../assets/product5.png";
import Product6 from "../../assets/product6.png";
import Product7 from "../../assets/product7.png";
import Product8 from "../../assets/product8.png";
import Product9 from "../../assets/product9.png";
import Product10 from "../../assets/product10.png";
import Product11 from "../../assets/product11.png";
import Product12 from "../../assets/product12.png";

import ProductRestaurant1 from "../../assets/showcases/restaurant/product1.JPG";
import ProductRestaurant2 from "../../assets/showcases/restaurant/product2.JPG";
import ProductRestaurant3 from "../../assets/showcases/restaurant/product3.JPG";
import ProductRestaurant4 from "../../assets/showcases/restaurant/product4.JPG";
import ProductRestaurant5 from "../../assets/showcases/restaurant/product5.JPG";
import ProductRestaurant6 from "../../assets/showcases/restaurant/product6.JPG";

const ShowcaseShipping = ({ sector, cartShippingAddress }) => {
	const { t } = useTranslation();
	const { creator } = useContext(CreatorContext);
	const [content, setContent] = useState([]);

	// Estado para el código de descuento
	const [discountCode, setDiscountCode] = useState("");

	// Función para calcular el total
	const calculateTotal = () => {
		switch (sector) {
			case "ecommerce":
				return "€44.98";
			case "restaurant":
				return "€44.98";

			default:
				return "€18";
		}
	};

	const shippingOptionsEcommerce = [
		{ name: t("shippingOptions.24hDelivery"), price: "€2.50" },
		{ name: t("shippingOptions.standardDelivery"), price: "€1.00" },
	];

	const shippingOptionsRestaurant = [
		{ name: t("shippingOptions.pickupAtRestaurant"), price: "€0" },
		{ name: t("shippingOptions.localDelivery"), price: "€5.00" },
	];

	return (
		<Box
			sx={{
				padding: 1,
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between",
				height: "100%",
			}}
		>
			<Box sx={{}}>
				<Typography variant="body2" gutterBottom>
					{cartShippingAddress}
				</Typography>
				<Box
					sx={{
						display: "flex",
						gap: 1,
						flexDirection: "column",
					}}
				>
					{(sector === "ecommerce"
						? shippingOptionsEcommerce
						: shippingOptionsRestaurant
					).map((option, index) => (
						<>
							<Box
								key={index}
								sx={{
									display: "flex",
									alignItems: "center",
									gap: 1,
								}}
							>
								{index === 0 ? (
									<CheckBoxIcon sx={{ fontSize: "14px" }} />
								) : (
									<CheckBoxOutlineBlankIcon sx={{ fontSize: "14px" }} />
								)}
								<Box
									sx={{
										display: "flex",
										flexDirection: "row",
										justifyContent: "space-between",
										flex: 1,
									}}
								>
									<Typography
										variant="body2"
										sx={{ fontWeight: "bold", fontSize: "8px" }}
									>
										{option.name}
									</Typography>
									<Typography variant="body2" sx={{ fontSize: "8px" }}>
										{option.price}
									</Typography>
								</Box>
							</Box>
							<Divider sx={{ marginTop: 0.3, marginBottom: 0.3 }}></Divider>
						</>
					))}
				</Box>
			</Box>

			<Box>
				<Divider sx={{ marginTop: 1, marginBottom: 1 }}></Divider>
				<Box sx={{ display: "flex", justifyContent: "space-between" }}>
					<Typography
						variant="body2"
						sx={{
							fontSize: "8px",
							textTransform: "inherit",
						}}
					>
						{t("cart.shipping")}
					</Typography>
					<Typography
						variant="body2"
						sx={{ fontSize: "8px", textTransform: "inherit" }}
					>
						-
					</Typography>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						marginBottom: 1,
					}}
				>
					<Typography
						variant="body2"
						sx={{
							fontWeight: "bold",
							fontSize: "8px",
							textTransform: "inherit",
						}}
					>
						{t("cart.total")}
					</Typography>
					<Typography
						variant="body2"
						sx={{
							fontWeight: "bold",
							fontSize: "8px",
							textTransform: "inherit",
						}}
					>
						{calculateTotal()}
					</Typography>
				</Box>

				<Button
					variant="contained"
					fullWidth
					sx={{
						backgroundColor: creator ? creator.color : "#45A049",
						"&:hover": {
							backgroundColor: creator ? creator.color : "#45A049",
						},
						color: creator && creator.whiteTextButton ? "#ffffff" : "#000000",
						fontSize: "8px",
						borderRadius: creator && creator.buttonRounded ? "24px" : "0px",
						fontWeight: "bold",
						textTransform: "uppercase",
						height: "28px",
						width: "100%",
					}}
				>
					{t("cart.continueOrder")}
				</Button>
			</Box>
		</Box>
	);
};

export default ShowcaseShipping;
